import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { GraphApiModule } from '@content-platform/web-angular-administration-shared-data-access-graph-api';
import { DevelopmentModule } from '@content-platform/web-angular-shared-util-development';
import { ContentPlatformUserService } from './interceptors/content-platform-user.service';
import { MsalInterceptorService } from './interceptors/msal-interceptor.service';
import { InterceptorDebugFlags } from './debug-flags';

@NgModule({
  imports: [CommonModule, GraphApiModule, DevelopmentModule.withFlags(InterceptorDebugFlags)],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ContentPlatformUserService,
      multi: true
    }
  ]
})
export class InterceptorsModule {}
